export default __webpack_public_path__ + "static/media/huapei.c0b182e4.png";